import React, { useContext, useEffect } from "react";
import BlogHeader from "../../Components/Blog/BlogHeader/BlogHeader";
import Footer from "../../Components/Footer";
import PopularArticles from "../../Components/Blog/PopularArticles/PopularArticles";
import Header from "../../Components/Header";
import userService from "../../services/userService";
import { useState } from "react";
import { ThemeContext } from "../../context/themeProvider";
import { message } from "antd";
import { blogData } from "../../Components/Blog/BlogData/BlogData";
import Blogs from "../../Components/Blog/Blogs/Blogs";

const BlogPage = () => {
  const { setLoading } = useContext(ThemeContext);
  const [recentBlogs, setRecentBlogs] = useState([]);
  const [oldBlog, setOldBlog] = useState([]);
  const reversOrder = [...recentBlogs].reverse();
  useEffect(() => {
    document.title = "Blog | BrainAlive";
    setOldBlog(blogData);
    getBlogData();
  }, []);

  const getBlogData = async () => {
    try {
      setLoading(true);

      const response = await userService.getAllBlogs();

      if (response.error) {
        message.destroy();
        message.error(response?.error?.message || "Something went worng!");
      } else {
        setRecentBlogs(response);
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
    setLoading(false);
  };

  return (
    <div id="blogHome">
      <Header />
      <BlogHeader recentBlogs={reversOrder} />
      <PopularArticles recentBlogs={reversOrder} oldBlog={oldBlog} />
      <Blogs recentBlogs={reversOrder} oldBlog={oldBlog} />
      <Footer />
    </div>
  );
};

export default BlogPage;
